<template>
  <div class="wrapper" v-if="show" id="loadsss">
    <div class="loading">
      <span
        :style="{
          width: '2.2rem',
          animationDuration:
            duration.indexOf('s') === -1 ? duration + 's' : duration,
          animationDelay: (parseInt(duration) / text.length) * index + 's',
        }"
        v-for="(char, index) in texts"
        :key="index"
      >
        {{ char }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: "加载中..",
    },
    duration: {
      type: String,
      default: "1s",
    },
  },
  data() {
    return {
      texts: "加载中..",
      show: false,
    };
  },
  methods: {},
  created() {
    // console.log(this.texts);
    // console.log(this.show);
    this.$forceUpdate();
  },
};
</script>
 
<style scoped>
.wrapper {
  display: flex;
  justify-content: center;
}
.loading {
  width: 100%;
  min-height: 100vh;
  height: 100%;
  display: flex;
  text-align: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.9);
  position: absolute;
  top: 0px;
  align-items: center;
  z-index: 99;
}
.loading span {
  margin-top: 0;
  animation: ease infinite move;
  display: block;
  font-size: 2rem;
}

@keyframes move {
  0% {
    margin-top: -0.4rem;
    border-bottom: 0.04rem solid;
  }
  50% {
    margin-top: 0.4rem;
    border-bottom: none;
  }
  100% {
    margin-top: -0.4rem;
  }
}
</style>
 